import React, { useState } from 'react';
import { uploadImage, STORAGE_PATHS } from '../../services/firebase-storage.js';
import { API } from '../../utils/database-frontend.js';

const ReferenceForm = ({ onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    altText: '',
    isFeatured: false,
    image: null
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.image) {
      onError('❌ Lütfen bir görsel seçin');
      return;
    }

    setLoading(true);
    
    try {
      // Upload image to Firebase Storage
      const uploadResult = await uploadImage(
        formData.image,
        STORAGE_PATHS.REFERENCES,
        `reference-${Date.now()}.${formData.image.name.split('.').pop()}`
      );

      // Add to PostgreSQL database
      const referenceData = {
        ImageUrl: uploadResult.url,
        FirebaseImagePath: uploadResult.path,
        AltText: formData.altText || 'Referans görseli',
        IsFeatured: formData.isFeatured
      };

      await API.references.create(referenceData);
      
      onSuccess('✅ Referans görseli başarıyla eklendi!');
      
      // Reset form
      setFormData({
        altText: '',
        isFeatured: false,
        image: null
      });
      
      // Reset file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      
    } catch (error) {
      onError('❌ Referans görseli eklenirken hata oluştu: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">🏢 Yeni Referans Görseli Ekle</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Görsel Açıklaması (Opsiyonel)
          </label>
          <input
            type="text"
            name="altText"
            value={formData.altText}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="Örn: Konya AVM Projesi"
          />
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            name="isFeatured"
            id="isFeatured"
            checked={formData.isFeatured}
            onChange={handleInputChange}
            className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
          />
          <label htmlFor="isFeatured" className="ml-2 block text-sm text-gray-700">
            Öne Çıkan Referans
          </label>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Referans Görseli
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            required
          />
          {formData.image && (
            <p className="mt-2 text-sm text-gray-600">
              Seçilen dosya: {formData.image.name}
            </p>
          )}
        </div>
        
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-purple-600 text-white py-2 px-4 rounded-md hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition duration-300"
        >
          {loading ? '⏳ Ekleniyor...' : '✅ Referans Ekle'}
        </button>
      </form>
    </div>
  );
};

export default ReferenceForm; 